import { Box } from '@aicon-dev/caas-core';
import { DeleteOutlined, LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { UploadFileTemp, UploadRenderProps } from './types';

type Props = UploadRenderProps;

export const UploadPictureList = (props: Props) => {
  const { fields, trigger, remove } = props;
  const { t } = useTranslation('global');

  return (
    <>
      {trigger}

      <Box as="ul" padding="0" margin="0">
        {fields.map((item) => (
          <FileItem key={item.id} fontSize={'14px'} status={item.status}>
            <LinkArea
              fileLinkExist={!!item.response?.url}
              href={item.response?.url}
              target="_blank"
            >
              <Box
                position="relative"
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="48px"
                height="48px"
                overflow="hidden"
                borderRadius="2px"
              >
                {item.status === 'uploading' ? (
                  <Spin
                    indicator={
                      <LoadingOutlined
                        style={{
                          color: '#00000073',
                          fontSize: '14px',
                        }}
                        spin
                      />
                    }
                  />
                ) : (
                  <StyledThumbnail
                    src={item.response?.thumbnailUrl}
                    alt={item.response?.filename}
                  />
                )}
              </Box>

              <TextArea>
                {item.response?.filename ||
                  item.response?.name ||
                  item.file?.name ||
                  t('global:wrong_file')}
              </TextArea>
            </LinkArea>

            {item.status !== 'uploading' && <DeleteButton onClick={() => remove(item)} />}
          </FileItem>
        ))}
      </Box>
    </>
  );
};

interface FileItemProps extends Partial<UploadFileTemp> {
  fontSize: string;
}
const FileItem = styled.li<FileItemProps>`
  position: relative;
  height: 66px;
  padding: 8px;

  display: flex;
  align-items: center;
  margin-top: 8px;

  color: #00000073;
  font-size: ${({ fontSize }) => fontSize};
  font-weight: 400;

  border: 1px solid #d9d9d9;
  border-radius: 2px;

  /* transition: background-color 0.2s ease; */
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  ${({ status }) => {
    if (status !== 'uploading') return null;
    return `
      border-style: dashed;
    `;
  }}
`;

const StyledThumbnail = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;

const LinkArea = styled.a<{ fileLinkExist: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  height: 100%;

  color: rgba(0, 0, 0, 0.8);
  text-decoration: none;
  transition: none;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ fileLinkExist }) =>
    !!fileLinkExist &&
    `
    cursor: pointer;
    color: #1890ff;
  `}
`;
const TextArea = styled.div`
  flex: 1;
  padding: 0 8px;
  min-width: 0;

  text-decoration: none;
  transition: none;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const DeleteButton = styled(DeleteOutlined)`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 22px;
  height: 22px;

  border-radius: 2px;

  transition: background-color 0.2s ease;

  &:hover {
    color: rgba(0, 0, 0, 0.8);
    background-color: rgba(0, 0, 0, 0.05);
  }
`;
